var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisputesCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 17.5073C19.1 17.9077 19.1 18.5083 18.7 18.9087C18.5 19.1089 18.3 19.209 18 19.209C17.7 19.209 17.5 19.1089 17.3 18.9087L12 13.6035L6.7 18.9087C6.5 19.1089 6.3 19.209 6 19.209C5.7 19.209 5.5 19.1089 5.3 18.9087C4.9 18.5083 4.9 17.9077 5.3 17.5073L10.6 12.2022L5.3 6.89697C4.9 6.49658 4.9 5.896 5.3 5.49561C5.7 5.09521 6.3 5.09521 6.7 5.49561L12 10.8008L17.3 5.49561C17.7 5.09521 18.3 5.09521 18.7 5.49561C19.1 5.896 19.1 6.49658 18.7 6.89697L13.4 12.2022L18.7 17.5073Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8169_53534",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 17.5073C19.1 17.9077 19.1 18.5083 18.7 18.9087C18.5 19.1089 18.3 19.209 18 19.209C17.7 19.209 17.5 19.1089 17.3 18.9087L12 13.6035L6.7 18.9087C6.5 19.1089 6.3 19.209 6 19.209C5.7 19.209 5.5 19.1089 5.3 18.9087C4.9 18.5083 4.9 17.9077 5.3 17.5073L10.6 12.2022L5.3 6.89697C4.9 6.49658 4.9 5.896 5.3 5.49561C5.7 5.09521 6.3 5.09521 6.7 5.49561L12 10.8008L17.3 5.49561C17.7 5.09521 18.3 5.09521 18.7 5.49561C19.1 5.896 19.1 6.49658 18.7 6.89697L13.4 12.2022L18.7 17.5073Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8169_53534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.19043H24V24.2139H0V0.19043Z",
    fill: "#4F4F4F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputesCloseIcon);
export default __webpack_public_path__ + "static/media/DisputesCloseIcon.ea997de13009137811d7a6433f821ae0.svg";
export { ForwardRef as ReactComponent };